import { Component, OnInit } from '@angular/core';
import { SidebarService, UserService } from '../../services/service.index';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styles: []
})
export class SidebarComponent implements OnInit {

  user:User;

  constructor(public _sidebarService:SidebarService, public _userService:UserService) { }

  ngOnInit() {
    this.user = this._userService.user;
    this._sidebarService.getMenu();
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/components/sidebar/sidebar.component.ts